import { render, staticRenderFns } from "./ReporteVentasRegalados.vue?vue&type=template&id=1b4b741d"
import script from "./ReporteVentasRegalados.vue?vue&type=script&lang=js"
export * from "./ReporteVentasRegalados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports